const env: any = process.env.REACT_APP_STAGE;

export const STAGES = {
  LOCAL: 'LOCAL',
  DEV: 'dev',
  PROD: 'PROD'
};

let _API_ = 'http://localhost:8080/';

let _ENV_NAME_ = STAGES.LOCAL;
switch (env) {
  case 'dev':
    _API_ = 'https://dev-api.aguacatecnia.mx/';
    _ENV_NAME_ = STAGES.DEV;

    break;
  case 'prod':
    _API_ = 'https://api.aguacatecnia.mx/';
    _ENV_NAME_ = STAGES.PROD;
    break;

  default:
    break;
}

export const API_ENDPOINT = _API_;

export const STORAGE = {
  TOKEN: 'aguacatecnia-token',
  USER: 'aguacatecnia-user',
  ACCOUNT: 'aguacatecnia-account',
  PERIOD: 'aguacatecnia-period',
  FILTER_REGISTERS: 'aguacatecnia-filter-registers',
}